import type {
	BehaviorPropertySnapshot,
	BehaviorPropertySnapshotSource
} from './types';

/**
 * Builds the optional propertySnapshot projected by lead-behavior-tracker.
 * asking_price prefers askingPrice (sale) and falls back to rentPrice.
 */
export function buildPropertySnapshot(
	property: BehaviorPropertySnapshotSource
): BehaviorPropertySnapshot {
	return {
		neighborhood: property.region,
		propertyType:
			property.propertyType?.identifier ?? property.propertyType?.name ?? null,
		asking_price: property.askingPrice ?? property.rentPrice ?? null,
		area: property.area ?? null,
		bedrooms: property.bedrooms ?? null,
		transactionType: property.ad?.transactionType ?? null
	};
}
